//
//
//
//
//
//
//
import echarts from 'echarts';
export default {
  props: ['chartData', 'lendName', 'xAxisData'],
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    this.initChart();
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            textStyle: {
              color: '#fff'
            }
          }
        },
        title: {},
        legend: {
          orient: 'vertical',
          x: 'right',
          left: '90%',
          data: this.lendName,
          width: '50%',
          align: 'left',
          textStyle: {
            fontSize: 12,
            color: 'normal'
          },
          itemHeight: 10,
          itemWidth: 10,
          top: '20',
          selectedMode: false
        },
        grid: {
          height: '220',
          borderWidth: 0,
          top: 110,
          bottom: 95,
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: [{
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            interval: 0
          },
          data: this.xAxisData
        }],
        yAxis: [{
          type: 'value',
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0
          },
          splitArea: {
            show: false
          }
        }],
        series: [{
          name: this.lendName[0],
          type: 'bar',
          stack: '总量',
          barMaxWidth: 20,
          barGap: '10%',
          itemStyle: {
            normal: {
              color: '#FFA500',
              label: {
                show: false,
                textStyle: {
                  color: '#fff'
                },
                position: 'inside',
                formatter: function formatter(p) {
                  return p.value > 0 ? p.value : '';
                }
              }
            }
          },
          data: this.chartData[0]
        }, {
          name: this.lendName[1],
          type: 'bar',
          stack: '总量',
          itemStyle: {
            normal: {
              color: '#FFF68F',
              barBorderRadius: 0,
              label: {
                show: false,
                position: 'inside',
                formatter: function formatter(p) {
                  return p.value > 0 ? p.value : '';
                }
              }
            }
          },
          data: this.chartData[1]
        }, {
          name: this.lendName[2],
          type: 'bar',
          stack: '总量',
          itemStyle: {
            normal: {
              color: '#FFDEAD',
              barBorderRadius: 0,
              label: {
                show: false,
                position: 'inside',
                formatter: function formatter(p) {
                  return p.value > 0 ? p.value : '';
                }
              }
            }
          },
          data: this.chartData[2]
        }, {
          name: this.lendName[3],
          type: 'bar',
          stack: '总量',
          itemStyle: {
            normal: {
              color: '#C71585',
              barBorderRadius: 0,
              label: {
                show: false,
                position: 'inside',
                formatter: function formatter(p) {
                  return p.value > 0 ? p.value : '';
                }
              }
            }
          },
          data: this.chartData[3]
        }, {
          name: this.lendName[4],
          type: 'bar',
          stack: '总量',
          itemStyle: {
            normal: {
              color: '#4169E1',
              barBorderRadius: 0,
              label: {
                show: false,
                position: 'inside',
                formatter: function formatter(p) {
                  return p.value > 0 ? p.value : '';
                }
              }
            }
          },
          data: this.chartData[4]
        }]
      });
    },
    initChart: function initChart() {
      console.log(this.chartData);
      this.chart = echarts.init(this.$refs.statusEchart, 'macarons');
      this.setOptions(this.chartData);
    }
  }
};